"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = exports.parse = void 0;
var history_1 = require("history");
var query_string_1 = require("query-string");
// import { getBettingOptions } from '../utils'; //TODO: update test and change import
var getBettingOptions_1 = __importDefault(require("../utils/getBettingOptions"));
var history = null;
function getHistory() {
    if (history)
        return history;
    var _a = getBettingOptions_1.default().url, bettingPath = _a.bettingPath, pagePath = _a.pagePath;
    var basename = pagePath || bettingPath;
    history =
        typeof window === 'undefined'
            ? history_1.createMemoryHistory()
            : history_1.createBrowserHistory({ basename: basename });
    return history;
}
exports.default = getHistory;
function parse(str) {
    return query_string_1.parse(str, { arrayFormat: 'bracket' });
}
exports.parse = parse;
function stringify(obj) {
    return query_string_1.stringify(obj, { arrayFormat: 'bracket' });
}
exports.stringify = stringify;
//# sourceMappingURL=history.js.map